import { callFunction } from './functionsClient';

export const previewImportWords = (payload, getAccessToken) =>
  callFunction('previewImportWords', payload, getAccessToken);
export const confirmImportWords = (payload, getAccessToken) =>
  callFunction('confirmImportWords', payload, getAccessToken);
